import { Link } from "react-router-dom";
import { useAuth } from "../../lib/useAuth";
import styles from "./ClientAccessCard.module.css";

export default function ClientAccessCard({ compact = false }) {
  const { user } = useAuth();

  return (
    <div className={`${styles.card} ${compact ? styles.compact : ""}`}>
      <span className="mono-tag">// acceso cliente</span>
      <p className={styles.text}>
        ¿Tiene un proyecto con nosotros? Dale seguimiento.
      </p>
      <Link to={user ? "/portal" : "/login"} className={styles.btn}>
        {user ? "Volver a dashboard" : "Iniciar sesión"}
        <svg viewBox="0 0 24 12" width="18" height="9" aria-hidden="true">
          <path d="M0 6 H22 M16 1 L22 6 L16 11" fill="none" stroke="currentColor" strokeWidth="1.4" />
        </svg>
      </Link>
    </div>
  );
}
